$(function () {
    let metrics = {};
    const container = document.getElementById("outer");
    const bar = document.getElementById("bar");
    const leftArrow = $(".toggleLeft");
    const rightArrow = $(".toggleRight");

    $(window).on('activate.bs.scrollspy', function (event, object) {
        doSlide('center', false);
    });

    function setMetrics() {
        metrics = {
            bar: bar.scrollWidth || 0,
            container: container.clientWidth || 0,
            left: container.getBoundingClientRect().x - bar.getBoundingClientRect().x,
            getHidden() {
                return this.bar - this.left - this.container
            }
        }

        updateArrows();
    }

    function doSlide(direction, animated) {
        setMetrics();
        const pos = metrics.left;
        const maxAmountToScroll = -(metrics.bar - metrics.container);
        let amountToScroll = 0;
        if (direction === "right") {
            const possibleNewLeft = -(Math.abs(pos) + metrics.container / 2);
            amountToScroll = Math.max(possibleNewLeft, maxAmountToScroll);
        } else if (direction === "left") {
            amountToScroll = Math.min(0, (metrics.container + pos));
        } else if (direction === "center") {
            const element = $(".campaign-subcategories .nav-link.active");
            const elementLeftOffset = element.position().left + element.width() / 2;
            const centeredAmountToScroll = -(elementLeftOffset - metrics.container / 2);
            amountToScroll = Math.max(Math.min(0, centeredAmountToScroll), maxAmountToScroll);
        }

        updateArrows();
        $(bar).animate({
            left: amountToScroll + "px"
        }, animated ? 200 : 0);

        setTimeout(function () {
            setMetrics();
        }, 400);
    }

    function updateArrows() {
        rightArrow.toggleClass('d-none', metrics.getHidden() === 0);
        leftArrow.toggleClass('d-none', metrics.left === 0);
    }

    leftArrow.click(function () {
        doSlide("left", true);
    });

    rightArrow.click(function () {
        doSlide("right", true);
    });

    $(window).resize(function () {
        doSlide("center", true);
    });

    setMetrics();
});
